/**
 * OpenAPI definition
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { JsonNode } from './jsonNode';
import { RuleTestFileRef } from './ruleTestFileRef';
import { RuleTestHybridPayload } from './ruleTestHybridPayload';
import { RuleTestIdsPayload } from './ruleTestIdsPayload';

export interface RuleTestStartRequest { 
    rulesetType?: RuleTestStartRequest.RulesetTypeEnum;
    rulesetId?: string;
    ruleKey?: string;
    editorDirty?: boolean;
    files?: Array<RuleTestFileRef>;
    ki?: JsonNode;
    hybrid?: RuleTestHybridPayload;
    ids?: RuleTestIdsPayload;
}
export namespace RuleTestStartRequest {
    export type RulesetTypeEnum = 'KI' | 'HYBRID' | 'CROSS' | 'IDS';
    export const RulesetTypeEnum = {
        KI: 'KI' as RulesetTypeEnum,
        HYBRID: 'HYBRID' as RulesetTypeEnum,
        CROSS: 'CROSS' as RulesetTypeEnum,
        IDS: 'IDS' as RulesetTypeEnum
    };
}